'use client'

import { cn } from '@/lib/utils'
import {
  parseAsArrayOf,
  parseAsInteger,
  parseAsString,
  useQueryStates,
} from 'nuqs'

type AllItemsTagProps = {
  label: string
}

const AllItemsTag = ({ label }: AllItemsTagProps) => {
  const [query, setQuery] = useQueryStates(
    {
      tags: parseAsArrayOf(parseAsString),
      page: parseAsInteger,
    },
    {
      shallow: false,
    },
  )

  const checked = query.tags === null || query.tags.length === 0

  return (
    <button
      className={cn(
        'border border-secondary-900 p-2 text-xs text-secondary-900 hover:bg-grey-500',
        checked && 'bg-grey-400',
      )}
      onClick={() => {
        setQuery({ tags: null, page: null })
      }}
    >
      {label}
    </button>
  )
}

export default AllItemsTag
